const routers = [
  {
    // 产品
    path: '/summary/list',
    name: 'summary',
    component: () => import('@/views/modules/summary/List.vue')
  }
]
export default routers
